import { Toaster } from 'react-hot-toast'
import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { makeTheme } from 'utils'
import AppRoutes from 'routes'
import { selectGlobal } from 'slices/global'
import { useAppSelector } from 'app/hooks'
import GlobalStyles from './GlobalStyles'
import ZoomRoot from 'components/ZoomRoot'
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css';


const App = () => {
  const { colorScheme } = useAppSelector(selectGlobal)
  const theme = makeTheme(colorScheme)

  return (
    <ZoomRoot>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        <Toaster />
        <AppRoutes />
      </ThemeProvider>
    </ZoomRoot>
  )
}

export default App